import { createIcon as e } from "../createIcon.js";
const o = {
  name: "ResourcesFullIcon",
  height: 1024,
  width: 1024,
  svgPath: "M512.1,0 C229.7,0 0,229.8 0,512 C0,794.3 229.8,1024 512.1,1024 C794.4,1024 1024,794.3 1024,512 C1024,229.7 794.4,0 512.1,0 Z M512,896 C300.2,896 128,723.9 128,512 C128,300.3 300.2,128 512,128 C723.7,128 896,300.2 896,512 C896,723.8 723.7,896 512,896 Z M512,224 C671.1,224 800,352.9 800,512 C800,671.1 671.1,800 512,800 C352.9,800 224,671.1 224,512 C224,352.9 352.9,224 512,224",
  yOffset: 0,
  xOffset: 0
}, s = e(o);
export {
  s as ResourcesFullIcon,
  o as ResourcesFullIconConfig,
  s as default
};
